import { useMemo } from 'react';
import { InfiniteQueryObserverSuccessResult } from 'react-query';
import { useOnScrollDown } from 'redesign';
import { GetPendingBankAccountsResponse } from 'hq/services/bank-account-service.types';
import { BankAccountTable } from './bank-account-table';

type BankAccountListProps = {
  infiniteQueryResult: InfiniteQueryObserverSuccessResult<GetPendingBankAccountsResponse, unknown>;
  allowEmploymentId: boolean;
};

export const BankAccountList = ({
  infiniteQueryResult,
  allowEmploymentId,
}: BankAccountListProps) => {
  const flatData = useMemo(
    () => infiniteQueryResult.data.pages.flatMap((page) => page.items),
    [infiniteQueryResult.data]
  );

  const { fetchIfBottomScrolled } = useOnScrollDown({
    infiniteQueryResult,
    flatData,
  });

  return (
    <BankAccountTable
      data={flatData}
      allowEmploymentId={allowEmploymentId}
      onScroll={fetchIfBottomScrolled}
    />
  );
};
